var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.80012C6 4.1636 6.25286 3.55315 6.70294 3.10306C7.15303 2.65297 7.76348 2.40012 8.4 2.40012H15.6C16.2365 2.40012 16.847 2.65297 17.2971 3.10306C17.7471 3.55315 18 4.1636 18 4.80012V21.6001L12 18.6001L6 21.6001V4.80012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave2);
export default __webpack_public_path__ + "static/media/save_2.ef300b145219d81bc10b2a257a9412de.svg";
export { ForwardRef as ReactComponent };